import type { FC } from 'react';

import {
  TeamMembersRequest,
  TeamMembersRequestCancelReason,
  TeamMembersRequestStatus,
} from '__generated__/GQL';
import Callout from 'components/_core/Callout';

import locales from './locales';

interface RequestStatusCalloutProps {
  request: Pick<TeamMembersRequest, 'status' | 'cancelReason'>;
}

const PROCESSING_REQUEST_STATUSES = [
  TeamMembersRequestStatus.Approved,
  TeamMembersRequestStatus.Processed,
];

const RequestStatusCallout: FC<RequestStatusCalloutProps> = ({ request }) => {
  if (request.status === TeamMembersRequestStatus.Canceled) {
    if (
      request.cancelReason === TeamMembersRequestCancelReason.InsufficientFunds
    ) {
      return (
        <Callout hideIcon marginBottom="space-24" variant="error">
          <Callout.Title>
            {locales.callouts.insufficientFunds.title}
          </Callout.Title>
          <Callout.Content>
            {locales.callouts.insufficientFunds.description}
          </Callout.Content>
        </Callout>
      );
    }

    return (
      <Callout hideIcon marginBottom="space-24" variant="error">
        <Callout.Title>{locales.callouts.genericError.title}</Callout.Title>
        <Callout.Content>
          {locales.callouts.genericError.description}
        </Callout.Content>
      </Callout>
    );
  }

  if (PROCESSING_REQUEST_STATUSES.includes(request.status)) {
    return (
      <Callout hideIcon marginBottom="space-24" variant="info">
        <Callout.Title>{locales.callouts.processing.title}</Callout.Title>
        <Callout.Content>
          {locales.callouts.processing.description}
        </Callout.Content>
      </Callout>
    );
  }

  return null;
};

export default RequestStatusCallout;
